/* eslint-disable no-param-reassign */
import produce from 'immer';

import { ActionType } from './job-interest.types';

const initialState = {
  jobInterest: {},
  jobInfo: {},
  developerInfo: {},
  isJobInterestDetailsFetching: false,
  isNotInterestedReasonsFetching: false,
  isFetching: false,
  notInterestedReasons: [],
  developerAvailabilityDetail: {},
  developerRateDetails: {},
  jobRequestFormData: null,
  jobRequestFormDataFetching: false,
};

export const jobInterestReducer = (state = initialState, action = '') => {
  return produce(state, (draftState) => {
    if (action.type === ActionType.JOB_REQUEST_FORM_DATA_START) {
      draftState.jobRequestFormDataFetching = true;
    } else if (action.type === ActionType.GET_JOB_REQUEST_FORM_DATA) {
      draftState.jobRequestFormData = action.payload;
    } else if (action.type === ActionType.JOB_REQUEST_FORM_DATA_COMPLETED) {
      draftState.jobRequestFormDataFetching = false;
    }

    if (action.type === ActionType.JOB_INTEREST_REQUEST) {
      draftState.isFetching = true;
    } else if (action.type === ActionType.JOB_INTEREST_COMPLETED) {
      draftState.isFetching = false;
    } else if (action.type === ActionType.JOB_INTEREST_DETAILS_FETCH_STARTED) {
      draftState.isJobInterestDetailsFetching = true;
    } else if (action.type === ActionType.JOB_INTEREST_DETAILS_FETCH_COMPLETED) {
      draftState.isJobInterestDetailsFetching = false;
    } else if (action.type === ActionType.GET_JOB_INTEREST_DETAILS) {
      draftState.jobInterest = { ...action.payload };
    } else if (action.type === ActionType.GET_JOB_INFO) {
      draftState.jobInfo = action.payload;
    } else if (action.type === ActionType.UPDATE_JOB_INTEREST_DETAILS) {
      draftState.jobInterest = { ...draftState.jobInterest, ...action.payload };
    } else if (action.type === ActionType.GET_DEVELOPER_INFO) {
      draftState.developerInfo = action.payload;
    } else if (action.type === ActionType.NOT_INTERESTED_REASONS_FETCH_STARTED) {
      draftState.isNotInterestedReasonsFetching = true;
    } else if (action.type === ActionType.NOT_INTERESTED_REASONS_FETCH_COMPLETED) {
      draftState.isNotInterestedReasonsFetching = false;
    } else if (action.type === ActionType.GET_NOT_INTERESTED_REASONS) {
      draftState.notInterestedReasons = action.payload;
    } else if (action.type === ActionType.GET_DEVELOPER_AVAILABILITY_FROM_HASH) {
      draftState.developerAvailabilityDetail = action.payload;
    } else if (
      action.type === ActionType.UPDATE_DEVELOPER_AVAILABILITY_STATUS_FROM_JOB_INTEREST_FORM
    ) {
      draftState.developerAvailabilityDetail = {
        ...(action.payload.updateFromDB ? { lastUpdated: new Date().toISOString() } : {}),
        ...action.payload.availabilityInformation,
      };
    } else if (action.type === ActionType.GET_DEVELOPER_RATE_DETAILS_FROM_JOB_INTEREST_FORM) {
      draftState.developerRateDetails = action.payload;
    }
  });
};
